import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { setLanguage } from "../../store/actions/themeActions";
import "../../vendor/styles/pages/authentication.scss";
import { apiClient } from "../../services/api";
import Input from "../../components/forms/Input";

import { Button, Dropdown, Form, Media, Modal, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
// import '../vendor/libs/sweetalert2/sweetalert2.scss'
import "../../vendor/libs/sweetalert2/sweetalert2.scss";
import _ from "lodash";

// intl messages
import IntlMessages from "../../Utils/IntlMessages";
import CommonAnnouncementCard from "../../components/card/announcement/CommonAnnouncementCardV2";
import LinkToAuthorizeLogin from "../../components/authentication/oauth/LinkToAuthorizeLogin";
import { useAuth } from "../../shared/hooks/useAuth";
import { useQuery } from "../../shared/hooks/useQuery";
import crypto from "crypto";

const LANGUAGE = [
  { id: "TH", locale: "th-TH", title: "THAI" },
  { id: "EN", locale: "en-US", title: "ENGLISH" },
];

const ReactSwal = withReactContent(
  Swal.mixin({
    buttonsStyling: false,
    customClass: {
      confirmButton: "btn btn-warning btn-lg",
      cancelButton: "btn btn-default btn-lg",
      actions: "text-center",
    },
  })
);

const forgotPwdUrl = "https://accounts.ku.ac.th/private/login";

const AuthenticationLoginV4 = (props) => {
  const { login } = useAuth();
  let [query, search] = useQuery();

  const [isLoading, setIsLoading] = useState(true);
  const [selectedLanguage, setSelectedLanguage] = useState(LANGUAGE[0]);
  const [news, setNews] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [currentAnncounceIndex, setCurrentAnncounceIndex] = useState(0);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [toggle, setToggle] = useState(false);

  const [showBackground, setShowBackground] = useState(false);

  useEffect(() => {
    let selectedLanguage = LANGUAGE.find(
      (lang) => lang.locale === props.locale
    );
    if (selectedLanguage) {
      setSelectedLanguage(selectedLanguage);
    }

    getNews();

    if (window.innerWidth < 992) {
      setModalShow(true);
    }
    const mediaQuery = window.matchMedia("(max-width: 991px)");
    const handleResize = () => setShowBackground(mediaQuery.matches);
    handleResize();
    mediaQuery.addEventListener("change", handleResize);
    return () => mediaQuery.removeEventListener("change", handleResize);
  }, []);

  const toggleDetail = () => {
    setToggle(!toggle);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      signin();
    }
  };

  const getNews = async () => {
    await apiClient
      .get("/usr-common/getAnnounceNews")
      .then((newsRes) => {
        console.log("news result", newsRes);
        setNews(newsRes.data.results);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const validateLogin = () => {
    if (!username || !password) {
      setShowAlert(true);
      return false;
    }
    return true;
  };

  const signin = async () => {
    if (!validateLogin()) {
      ReactSwal.fire({
        title: "ไม่สามารถเข้าสู่ระบบได้",
        // text: 'Please contact administrator.',
        text: "กรุณาระบุรหัสผู้ใช้งานและรหัสผ่าน",

        type: "warning",
        // footer: (<a href="#d" onClick={this.prevent}>Why do I have this issue?</a>)
      });

      console.log("ERROR_AUTHEN");

      return;
    }

    const redirectUrl = query.get("intent");

    const uname =
      process.env.REACT_APP_ENCRYPT === "Y" ? loginEncrypt(username) : username;
    const pword =
      process.env.REACT_APP_ENCRYPT === "Y" ? loginEncrypt(password) : password;

    if (redirectUrl) {
      await login(uname, pword, redirectUrl);
    } else {
      await login(uname, pword);
    }
  };

  const onChangeLanguage = (id) => {
    let selectedLanguage = LANGUAGE.find((lang) => lang.id === id);
    setSelectedLanguage(selectedLanguage);

    //redux action
    props.setLanguage(selectedLanguage.locale);
    console.log("change language action", selectedLanguage);
  };

  const onValueChange = (field, e) => {
    let textValue = e.target.value;

    if (field === "email") {
      textValue = textValue.replace(/[^A-Za-z0-9_]/gi, "");
      setUsername(textValue);
    } else {
      setPassword(textValue);
    }
  };

  const renderLoading = () => {
    return (
      <div
        className="row"
        style={{ height: "100%", alignItems: "center", minHeight: "10vh" }}
      >
        <div className="col-12 text-center">
          <Spinner animation="grow" variant="success" />
          <span style={{ color: "rgba(0, 0, 0, 0.65)", fontWeight: 600 }}>
            Loading...
          </span>
        </div>
      </div>
    );
  };

  const renderNewsMobile = () => {
    return (
      <Modal show={modalShow} onHide={() => setModalShow(false)} centered>
        {/* <div className="ui-bg-overlay bg-dark opacity-50"> </div> */}
        <Modal.Header closeButton>
          <Modal.Title>
            <svg
              width="23"
              height="23"
              viewBox="0 0 23 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M23 11.5003C23 5.14834 17.8512 0 11.5002 0C5.14882 0 0 5.14838 0 11.5003C0 17.8512 5.14877 23 11.5002 23C17.8512 23 23 17.8512 23 11.5003Z"
                fill="#E5AA17"
              />
              <path
                d="M23 11.5003C23 5.14834 17.8512 0 11.5002 0C5.14882 0 0 5.14838 0 11.5003C0 17.8512 5.14877 23 11.5002 23C17.8512 23 23 17.8512 23 11.5003Z"
                fill="url(#paint0_linear)"
              />
              <path
                d="M12.3637 5.99327C12.2057 5.90747 12.0133 5.91503 11.8625 6.01298L7.45232 8.87737H5.82225C5.5513 8.87737 5.33167 9.097 5.33167 9.36791V13.6664C5.33167 13.9374 5.5513 14.157 5.82225 14.157H7.45232L11.8625 17.0213C11.9435 17.074 12.0365 17.1005 12.1297 17.1005C12.2101 17.1005 12.2906 17.0808 12.3638 17.041C12.5219 16.9552 12.6203 16.7898 12.6203 16.6099V6.42443C12.6203 6.24457 12.5218 6.07908 12.3637 5.99327Z"
                fill="white"
              />
              <path
                d="M13.9845 14.9873C14.0259 14.9873 14.068 14.9798 14.109 14.9639C15.2326 14.5276 15.9875 13.1797 15.9875 11.6096C15.9875 10.2209 15.3756 8.96508 14.4285 8.41015C14.2647 8.3141 14.054 8.36921 13.9579 8.53308C13.8618 8.69695 13.9169 8.90773 14.0808 9.00369C14.8211 9.43749 15.2995 10.4604 15.2995 11.6095C15.2995 12.8778 14.7076 13.9934 13.8599 14.3225C13.6829 14.3912 13.595 14.5906 13.6638 14.7677C13.7167 14.9039 13.8467 14.9873 13.9845 14.9873Z"
                fill="white"
              />
              <path
                d="M14.8829 16.4218C14.9244 16.4218 14.9665 16.4142 15.0074 16.3984C16.5856 15.7856 17.6878 13.8034 17.6878 11.5779C17.6878 9.57594 16.8124 7.76948 15.4576 6.97573C15.2938 6.87963 15.083 6.93475 14.987 7.09867C14.8909 7.26249 14.9459 7.47327 15.1099 7.56923C16.258 8.24195 16.9998 9.81546 16.9998 11.5779C16.9998 13.5261 16.0781 15.2447 14.7584 15.7571C14.5813 15.8258 14.4935 16.0251 14.5622 16.2023C14.6151 16.3384 14.7451 16.4218 14.8829 16.4218Z"
                fill="white"
              />
              <defs>
                <linearGradient
                  id="paint0_linear"
                  x1="11.5"
                  y1="0"
                  x2="11.5"
                  y2="23"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFCE7F" />
                  <stop offset="1" stopColor="#DD1374" />
                </linearGradient>
              </defs>
            </svg>
            <span
              style={{
                paddingLeft: 8,
                fontSize: 16,
                fontWeight: 600,
                color: "#000000",
              }}
            >
              {<IntlMessages id="LOGIN__ANNOUNCEMENT" />}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={styles.newsPopupContainer}
          className="news-container w-100 text-white"
        >
          <div
            style={{ height: "55vh", padding: 0 }}
            className="news-item-container"
          >
            {isLoading
              ? renderLoading()
              : news.map((announce, index) => {
                return (
                  <div key={index} className="d-flex flex-row  news-item">
                    <span className="col-news-bullet">
                      <img
                        src={`${process.env.PUBLIC_URL}/img/news-bullet.png`}
                        alt=""
                      ></img>
                    </span>
                    <div className="col-news-content">
                      <div className="news-item-text">
                        <CommonAnnouncementCard
                          {...props}
                          announcement={announce}
                          detail={announce.announce_message_th}
                          announceDate={announce.updated_dt}
                          announceBy={
                            props.setting.locale === "th-TH"
                              ? announce.teachername
                              : announce?.teachername_en
                          }
                          announceSubject={announce.announce_subject_th}
                          useLoginStyle={true}
                          mobileView
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </Modal.Body>
        <div style={styles.tipsText}>
          <p style={{ textAlign: "center", fontSize: "0.75rem" }}>
            แตะที่ใดก็ได้เพื่อออกจากหน้าจอนี้
          </p>
        </div>
      </Modal>
    );
  };

  console.log("news", news);

  return (
    <div
      className="authentication-wrapper authentication-3"
      style={{ height: 100 }}
    >
      <div
        id="authentication-container"
        className="authentication-inner justify-content-center bg-white"
      >
        {/* Side container */}{" "}
        {/* Do not display the container on extra small, small and medium screens */}
        <div
          className="d-none d-lg-flex col-lg-8 align-items-center ui-bg-cover ui-bg-overlay-container p-5"
          style={{
            backgroundImage: `url('${process.env.PUBLIC_URL}/img/login_background.png')`,
            backgroundSize: "cover",
          }}
        >
          {_.size(news) > 0 && (
            <div className="news-container w-100 ">
              <div>
                <div className="news-header">
                  <div className="news-icon">
                    <i className="ion ion-md-text" />
                  </div>
                  <div style={{ marginLeft: 5 }}>
                    {<IntlMessages id="LOGIN__ANNOUNCEMENT" />}
                  </div>
                </div>
                {/* ประกาศ items */}
                {isLoading ? (
                  <div
                    className="row"
                    style={{
                      height: "100%",
                      alignItems: "center",
                      minHeight: "10vh",
                    }}
                  >
                    <div className="col-12 text-center">
                      <Spinner animation="grow" variant="success" />
                      <span
                        style={{
                          color: "rgba(0, 0, 0, 0.65)",
                          fontWeight: 600,
                        }}
                      >
                        Loading...
                      </span>
                    </div>
                  </div>
                ) : (
                  <div className="news-item-container">
                    {news.map((announce, index) => {
                      return (
                        <div
                          className="row row-cols-2 news-item"
                          key={
                            String(index) + String(announce.announce_subject_th)
                          }
                        >
                          <div className="col-news-bullet">
                            <img
                              src={`${process.env.PUBLIC_URL}/img/news-bullet.png`}
                              alt=""
                            ></img>
                          </div>
                          <div className="col-news-content">
                            <div className="news-item-text">
                              <CommonAnnouncementCard
                                {...props}
                                announcement={announce}
                                detail={announce.announce_message_th}
                                announceDate={announce.updated_dt}
                                announceBy={
                                  props.setting.locale === "th-TH"
                                    ? announce.teachername
                                    : announce?.teachername_en
                                }
                                announceSubject={announce.announce_subject_th}
                                useLoginStyle={true}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                {/* end item */}
              </div>
            </div>
          )}

          {/*{_.size(news) > 0 && (*/}
          {/*  <div className="" style={{ width: '100%' }}>*/}
          {/*    <div>*/}
          {/*      /!* ประกาศ items *!/*/}
          {/*      {isLoading ? (*/}
          {/*        renderLoading()*/}
          {/*      ) : (*/}
          {/*        <div className="news-container" >*/}
          {/*          <CommonAnnouncementCard*/}
          {/*            {...props}*/}
          {/*            announcement={news[currentAnncounceIndex]}*/}
          {/*            detail={news[currentAnncounceIndex].announce_message_th}*/}
          {/*            announceDate={news[currentAnncounceIndex].updated_dt}*/}
          {/*            announceBy={*/}
          {/*              props.setting.locale === 'th-TH' ? news[currentAnncounceIndex].teachername : news[currentAnncounceIndex]?.teachername_en*/}
          {/*            }*/}
          {/*            announceSubject={news[currentAnncounceIndex].announce_subject_th}*/}
          {/*            useLoginStyle={true}*/}
          {/*          />*/}
          {/*        </div>*/}
          {/*      )}*/}

          {/*      /!* end item *!/*/}
          {/*    </div>*/}
          {/*    <div className="news-selector-container">*/}
          {/*      {news.map((n, index) => {*/}
          {/*        return currentAnncounceIndex === index ? (*/}
          {/*          <img*/}
          {/*            key={index}*/}
          {/*            src={`${process.env.PUBLIC_URL}/img/e113.png`}*/}
          {/*            alt={`selector${currentAnncounceIndex}`}*/}
          {/*            className="new-selector"*/}
          {/*            title={props.setting.locale === 'th-TH' ? n.announce_subject_th : n.announce_subject_en}*/}
          {/*          />*/}
          {/*        ) : (*/}
          {/*          <img*/}
          {/*            key={index}*/}
          {/*            src={`${process.env.PUBLIC_URL}/img/e114.png`}*/}
          {/*            onClick={() => setCurrentAnncounceIndex(index)}*/}
          {/*            alt={`selector${currentAnncounceIndex}`}*/}
          {/*            className="new-selector"*/}
          {/*            title={props.setting.locale === 'th-TH' ? n.announce_subject_th : n.announce_subject_en}*/}
          {/*          />*/}
          {/*        )*/}
          {/*      })}*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*)}*/}
          {/* /.Text */}
        </div>
        <div
          id="form-login"
          className="d-flex col-lg-8 col-xl-4 v4loginbox mobileLogin"
          style={
            showBackground
              ? {
                backgroundImage: `url('${process.env.PUBLIC_URL}/img/login_background.png')`,
                backgroundSize: "cover",
                height: "100%",
              }
              : {}
          }
        >
          <div className="group__button-language">
            <Dropdown>
              <Dropdown.Toggle
                variant="link"
                id="dropdown-basic"
                className="language-dropdown"
              >
                {selectedLanguage.id}
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown__menu">
                {LANGUAGE.map((item) => (
                  <Dropdown.Item
                    key={item.id}
                    onClick={() => onChangeLanguage(item.id)}
                    className="menu__item"
                  >
                    {item.id}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div
            style={
              showBackground
                ? {
                  backgroundColor: "#fff",
                  height: "max-content",
                  padding: "30px",
                  borderRadius: "20px",
                  alignSelf: "center",
                }
                : {}
            }
            className="d-flex col-sm-7 col-md-7 col-lg-12 px-lg-0 v4loginform"
          >
            <div className="w-100">
              {/* Logo */}
              <div
                className=""
                style={{ marginBottom: 30, textAlign: "center" }}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/img/KU_Logo_PNG.png`}
                  alt="Brand"
                  className="login-logo"
                />
              </div>
              {/* / Logo */}
              <h3
                style={{
                  fontWeight: "bold",
                  color: "#006C68",
                  textAlign: "center",
                }}
              >
                {<IntlMessages id="login.title" />}
              </h3>
              {process.env.REACT_APP_OAUTH_FLAG == "Y" && (
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <LinkToAuthorizeLogin />
                </div>
              )}
              {/* <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: "20px 0",
                }}
              >
                <hr style={{ flex: 1, borderTop: "1px solid #B4B4B4" }} />
                <span
                  style={{
                    margin: "0 10px",
                    color: "#007AFF",
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                  }}
                  onClick={() => toggleDetail()}
                >
                  <span>
                    <IntlMessages id="COMMON_YOU_CAN_LOG_IN_WITH" />{" "}
                  </span>
                  <span className="text-center align-items-center">
                    {" "}
                    {toggle && (
                      <i className="ion ion-ios-arrow-up align-self-center"></i>
                    )}
                    {!toggle && (
                      <i className="ion ion-ios-arrow-down align-self-center"></i>
                    )}
                  </span>
                </span>
                <hr style={{ flex: 1, borderTop: "1px solid #B4B4B4" }} />
              </div>
              
              <form className="">
                {toggle && (
                  <>
                    <Form.Group>
                      <Form.Label>
                        {" "}
                        {<IntlMessages id="login.username" />}{" "}
                      </Form.Label>
                      <Input
                        onKeyPress={handleKeyPress}
                        value={username}
                        onChange={onValueChange}
                        field="email"
                        maxLength={24}
                        placeholder={
                          props.setting.messages["LOGIN__PLACEHOLDER_LOGIN"]
                        }
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label className="d-flex justify-content-between align-items-end">
                        <div> {<IntlMessages id="login.password" />} </div>
                      </Form.Label>
                      <Input
                        onKeyPress={handleKeyPress}
                        type="password"
                        value={password}
                        onChange={onValueChange}
                        field="password"
                        maxLength={16}
                        placeholder={
                          props.setting.messages["LOGIN__PLACEHOLDER_PWD"]
                        }
                      />
                    </Form.Group>

                    <div>
                      <a href={forgotPwdUrl} className=" small">
                        {<IntlMessages id="LOGIN__FORGOT_PWD" />}
                      </a>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <Button
                        variant="outline-success"
                        block
                        style={{ marginTop: 20 }}
                        onClick={() => signin()}
                      >
                        {<IntlMessages id="LOGIN__LOGIN" />}
                      </Button>
                    </div>
                  </>
                )}
                <div className="small text-center">
                  <IntlMessages id="COMMON_MORE_DETAIL" />{" "}
                  <a
                    href="https://registrar.ku.ac.th/contact-us/"
                    target="_blank"
                  >
                    <IntlMessages id="LOGIN__CONTACT_US" />
                  </a>
                </div>
              </form> */}

              <div className="small text-center">
                <IntlMessages id="COMMON_MORE_DETAIL" />{" "}
                <a
                  href="https://registrar.ku.ac.th/contact-us/"
                  target="_blank"
                >
                  <IntlMessages id="LOGIN__CONTACT_US" />
                </a>
              </div>

              {/* / Form */}
            </div>
          </div>

          {/* <div className="w-100" style={styles.contactContainer}>
                     <div className="text-center text-muted" style={{ fontSize: '0.688rem' }}>
                     กองบริหารการศึกษา (กพส.) <br /> เบอร์โทร 06-1454-2505 หรือ 034-341545-6 Fax. 034-351395
                     </div>
                     </div> */}
        </div>
        {/* / Form container */}
      </div>
      {_.size(news) > 0 && renderNewsMobile()}
    </div>
  );
};

export default connect(
  (store) => ({
    setting: store.theme,
  }),
  {
    setLanguage,
  }
)(AuthenticationLoginV4);

const styles = {
  contactContainer: {
    position: "absolute",
    bottom: "0.5rem",
    marginRight: "-2rem",
    marginLeft: "-2rem",
  },
  newsPopupContainer: {
    height: "60vh",
    paddingBottom: 0,
    paddingTop: "0",
    paddingLeft: "1rem",
    paddingRight: "0.5rem",
    border: "none",
  },
  newsHeader: {
    paddingLeft: 0,
  },
  closeModal: {
    position: "absolute",
    fontSize: "1.3rem",
    right: "0.5rem",
    width: "3rem",
    height: "3rem",
    justifyContent: "flex-end",
    display: "flex",
  },
  tipsText: {
    position: "absolute",
    bottom: "-10%",
    color: "#FFF",
    width: "100%",
  },
};

export function loginEncrypt(toEncrypt) {
  const publicKey = `-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAytOhlq/JPcTN0fX+VqObE5kwIaDnEtso2KGHdi9y7uTtQA6pO4fsPNJqtXOdrcfDgp/EQifPwVRZpjdbVrD6FgayrQQILAnARKzVmzwSMDdaP/hOB6i9ouKsIhN9hQUmUhbhaMkh7UXoxGW+gCSK8dq0+FJVnlt1dtJByiVAJRi2oKSdLRqNjk8yGzuZ6SrEFzAgYZwmQiywUF6V1ZaMUQDz8+nr9OOVU3c6Z2IQXCbOv6S7TAg0VhriFL18ZxUPS6759SuKC63VOOSf4EEHy1m0qBgpCzzlsB7D4ssF9x0ZVXLREFrqikP71Hg6tSGcu4YBKL+VwIDWWaXzz6szxeDXdYTA3l35P7I9uBUgMznIjTjNaAX4AXRsJcN9fpF7mVq4eK1CorBY+OOzOc+/yVBpKysdaV/yZ+ABEhX93B2kPLFSOPUKjSPK2rtqE6h2NSl5BFuGEoVBerKn+ymOnmE4/SDBSe5S6gIL5vwy5zNMsxWUaUF5XO9Ez+2v8+yPSvQydj3pw5Rlb07mAXcI18ZYGClO6g/aKL52KYnn1FZ/X3r8r/cibfDbuXC6FRfVXJmzikVUqZdTp0tOwPkh4V0R63l2RO9Luy7vG6rurANSFnUA9n842KkRtBagQeQC96dbC0ebhTj+NPmskklxr6/6Op/P7d+YY76WzvQMvnsCAwEAAQ==
-----END PUBLIC KEY-----`;
  const buffer = Buffer.from(toEncrypt, "utf8");
  const encrypted = crypto.publicEncrypt(
    {
      key: publicKey,
      passphrase: "",
      padding: crypto.constants.RSA_PKCS1_OAEP_PADDING,
    },
    buffer
  );
  return encrypted.toString("base64");
}
